export default __webpack_public_path__ + "static/media/search-normal.f4ec1841.svg";